import React from 'react';

function Button(props) {
    return (
        <button className="btn btn-primary" {...props}>{props.text}</button>
    );
}

export default Button;